// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const PingIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={1.5}
      d="M2.66 13.24H6.9l2.33-7.46 2.25 12.44 2.73-8.45 1.94 6.33 1.57-2.87 3.61.02"
    />
  </svg>,
  "Ping",
);
export default PingIcon;
